<mat-icon>
    <a
        #tooltip="matTooltip"
        matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.DELETE' | transloco }}"
        [matTooltipPosition]="tooltip_position"
        (click)="open(mymodal_delete)"
        >delete</a
    >
</mat-icon>

<ng-template #mymodal_delete let-modal>
    <div class="modal-header">
        <h4 i118n>{{ 'SETTING_PAGE.IDMS_SETTINGS.CONFIRM_SHARED_CONTENT_DELETE' | transloco }}</h4>
        <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modal.close('Ok click')">
            <i class="flaticon2-cross"></i>
        </a>
    </div>
    <div class="modal-body output-lable">
        <div class="row">
            <div class="col-md-12" style="padding: 15px">
                <p i118n>{{ 'SETTING_PAGE.IDMS_SETTINGS.ARE_YOU_SURE_YOU_WANT_TO_PERMANENTLY_REMOVE_THIS_SHARED_CONTENT_AND_ITS_IMAGE' | transloco }}</p>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn primary-ebtn" (click)="btnDeleteSharedContent()">{{ 'SETTING_PAGE.IDMS_SETTINGS.OK' | transloco }}</button>
        <button type="button" class="btn secondary-ebtn" (click)="modal.close('Ok click')">{{ 'SETTING_PAGE.IDMS_SETTINGS.CANCEL' | transloco }}</button>
    </div>
</ng-template>
